import React, { useState, useRef, useEffect, useContext } from "react";
import { useParams, Link } from "react-router-dom";
import axios from "axios";

// Data & Context
import circleData from "./circles.json";
import { AuthContext } from "../../context/App-Context";
import OcancerzStarszPostItems from "../OcancerzStarsz/OcancerzStarszPostItems";
import OcancerzStarFormItems from "../OcancerzStarForms/OcancerzStarFormItems";
import OcancerzStarFormList from "../OcancerzStarForms/OcancerzStarFormList";
import OcancerzStarzPostList from "../OcancerzStarsz/OcancerzStarzPostList";
import TgridEditorForm from "../../temple/templegridroom/Flex/TgridEditorForm/TgridEditorForm";

const OcancerzWorldStartingConsole = (props) => {
  const { UsernameUserID } = useParams();
  const auth = useContext(AuthContext);

  // ==========================================
  // STATE MANAGEMENT
  // ==========================================

  const controlBtnStyle = {
    background: "white",
    color: "white", // Deep Blue Text
    border: "1px solid #7b00ff",
    padding: "6px 12px",
    borderRadius: "6px",
    cursor: "pointer",
    fontSize: "0.85rem",
    boxShadow: "0 2px 5px rgba(0,0,0,0.1)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    fontWeight: "bold",
  };
  const [data, setData] = useState(null);
  const [activeTab, setActiveTab] = useState("posts");
  // 🌟 NEW: State for the Currents (News) sub-tabs
  const [currentsTab, setCurrentsTab] = useState("Electricity");
  const [editingPost, setEditingPost] = useState(null);
  // 🌟 NEW: State for the Catacombs sub-tabs
  const [catacombsTab, setCatacombsTab] = useState("Dead zones");
  const [isFullscreen, setIsFullscreen] = useState(false);
  const [zoom, setZoom] = useState(1);
  const [leftSidebarOpen, setLeftSidebarOpen] = useState(false);
  const [newPostInput, setNewPostInput] = useState("");

  const [isStellaPost, setIsStellaPost] = useState(false);
  const [selectedPhotos, setSelectedPhotos] = useState([]);
  const [showCamera, setShowCamera] = useState(false);
  // const [isTimestampEnabled, setIsTimestampEnabled] = useState(false);

  const [isHideStadia, setIsHideStadia] = useState(false);
  const [linkStatia, setLinkStatia] = useState([""]); // Array of link inputs
  const [mergeStatia, setMergeStatia] = useState([""]); // Array of merge inputs

  // 🌟 NEW: State for the Bill of Rights floating tab
  const [isBillOfRightsOpen, setIsBillOfRightsOpen] = useState(false);
  // --- SUBMITTING STATES ---
  const [isSubmittingStar, setIsSubmittingStar] = useState(false);
  const [isSubmittingConstellation, setIsSubmittingConstellation] =
    useState(false);

  const [theOcancerStarPosts, settheOcancerStarPosts] = useState(null);
  const [theOcancerStarForms, settheOcancerStarForms] = useState(null);

  const [starPlace, setStarPlace] = useState("eternity");
  const [constellationPlace, setConstellationPlace] = useState("eternity");

  // const [editingPost, setEditingPost] = useState(null);
  const [refreshFeed, setRefreshFeed] = useState(0);

  const [isOcancerzSignActive, setIsOcancerzSignActive] = useState(false);
  const [isOcancerzSignActive2, setIsOcancerzSignActive2] = useState(false);

  // The available sectors in the Metaverse
  const osLocations = [
    "eternity",
    "void",
    "sanctuary",
    "home",
    "skyline",
    "catacombs",
    "currents",
    "space",
  ];

  // 🌟 NEW: State for the Home Archive Sidebar (PASTED HERE AFTER THE POST VARIABLES EXIST)
  const [homeTab, setHomeTab] = useState("stars");

  // 🌟 NEW: Group the fetched data by Date (Month/Day/Year)
  const groupedHomeData = React.useMemo(() => {
    const dataToGroup =
      homeTab === "stars" ? theOcancerStarPosts : theOcancerStarForms;
    if (!dataToGroup || !dataToGroup.length) return {};

    const groups = {};
    dataToGroup.forEach((post) => {
      let dateLabel = "Recent";
      if (post?.postDate) {
        // Formats "10:30 am edt, september 7, 2026" -> "september 7, 2026"
        const parts = post.postDate.split(",");
        if (parts.length > 1) {
          dateLabel = parts.slice(1).join(",").trim().toUpperCase();
        } else {
          dateLabel = post.postDate.toUpperCase();
        }
      }
      if (!groups[dateLabel]) groups[dateLabel] = [];
      groups[dateLabel].push(post);
    });
    return groups;
  }, [homeTab, theOcancerStarPosts, theOcancerStarForms]);

  // (Your existing useEffect fetchAllData goes right below this)

  // --- CLEAR FORM FUNCTIONS ---
  const clearStarForm = () => {
    setNewPostInput("");
    setIsStellaPost(false);
    setIsHideStadia(false);
    setLinkStatia([""]);
    setMergeStatia([""]);
    selectedPhotos.forEach((img) => {
      if (img.previewUrl) URL.revokeObjectURL(img.previewUrl);
    });
    setSelectedPhotos([]);
    if (fileInputRef.current) fileInputRef.current.value = "";
  };

  // Temporary Frontend Interceptor
  //   axios.interceptors.request.use((request) => {
  //     if (request.url.includes("createOcancerzoOSStarPost")) {
  //       console.log("🚀 [AXIOS INTERCEPT] Request leaving browser:", {
  //         url: request.url,
  //         method: request.method,
  //         withCredentials: request.withCredentials,
  //         hasFormData: request.data instanceof FormData,
  //       });
  //     }
  //     return request;
  //   });

  // Wrap this in React.useCallback to stop it from rebuilding on every keystroke
  const handleAddPostToMergeStar = React.useCallback((postId) => {
    setMergeStatia2((prev) => {
      // 🌟 NEW: Check if the star is already in the queue
      if (prev.includes(postId)) {
        return prev;
      }

      let newArray;
      if (prev.length === 1 && prev[0] === "") {
        newArray = [postId];
      } else {
        newArray = [...prev, postId];
      }
      return newArray;
    });

    setRightSidebarOpen(true);
  }, []); // <-- Empty array locks the function in place

  const clearConstellationForm = () => {
    setNewPostInput2("");
    setIsStellaPost2(false);
    setIsHideStadia2(false);
    setLinkStatia2([""]);
    setMergeStatia2([""]);
    selectedPhotos2.forEach((img) => {
      if (img.previewUrl) URL.revokeObjectURL(img.previewUrl);
    });
    setSelectedPhotos2([]);
    if (fileInputRef2.current) fileInputRef2.current.value = "";
  };

  // --- SUBMIT HANDLERS ---

  // Array Handlers for dynamically adding/updating inputs
  const updateArrayInput = (setter, index, value) => {
    setter((prev) => {
      const newArr = [...prev];
      newArr[index] = value;
      return newArr;
    });
  };

  useEffect(() => {
    // Only fetch if we have a logged-in user AND we haven't already fetched the data
    if (!auth.loginVar || theOcancerStarPosts || theOcancerStarForms) return;

    const fetchAllData = async () => {
      try {
        const [postsResponse, formsResponse] = await Promise.all([
          axios.get(
            `${process.env.REACT_APP_BACKEND_URL}/zeusapolis/ocancerz-metavz/getusertgOcancerStarPosts/${auth.loginVar}`
          ),
          axios.get(
            `${process.env.REACT_APP_BACKEND_URL}/zeusapolis/ocancerz-metavz/getusertgOcancerStarForms/${auth.loginVar}`
          ),
        ]);

        // console.log(postsResponse.data.data.functionGo);
        // console.log(formsResponse.data.data.functionGo);
        settheOcancerStarPosts(postsResponse.data.data.functionGo);
        settheOcancerStarForms(formsResponse.data.data.functionGo);
      } catch (err) {
        console.error("Failed to load Ocancerz posts", err);
      }
    };

    fetchAllData();
  }, [auth.loginVar, theOcancerStarForms, theOcancerStarPosts]);

  const addArrayInput = (setter) => setter((prev) => [...prev, ""]);

  const fileInputRef = useRef(null);
  const videoRef = useRef(null);
  const streamRef = useRef(null);

  // Add zoom handlers
  const handleZoomIn = () => setZoom((prev) => Math.min(prev + 0.2, 3));
  const handleZoomOut = () => setZoom((prev) => Math.max(prev - 0.2, 0.5));

  // 1. DEFAULT TO 'const' (Ocancerz) instead of 'grid'
  const [viewMode, setViewMode] = useState("const");

  // 2. DEFAULT TO 'eternity'
  const [activePanel, setActivePanel] = useState("eternity");

  const [isCodeInput, setIsCodeInput] = useState(false);
  const codeTextAreaRef = useRef(null);

  const [circles, setCircles] = useState(circleData);
  const [dragging, setDragging] = useState(false);
  const [offset, setOffset] = useState({ x: 0, y: 0 });
  const svgRef = useRef(null);

  //   // --- CAMERA ENHANCEMENT STATES ---
  //   const [activeCameraTarget, setActiveCameraTarget] = useState("star"); // Tracks which sidebar opened it
  //   const [currentFacingMode, setCurrentFacingMode] = useState("user");
  //   const [hasMultipleCameras, setHasMultipleCameras] = useState(false);

  // --- ENHANCED CAMERA FUNCTIONS ---
  // --- CAMERA ENHANCEMENT STATES ---
  const [activeCameraTarget, setActiveCameraTarget] = useState("star");
  const [currentFacingMode, setCurrentFacingMode] = useState("user");
  const [hasMultipleCameras, setHasMultipleCameras] = useState(false);

  // New States for Preview & Retake Flow
  const [capturedPhoto, setCapturedPhoto] = useState(null);
  const [latestCaptureId, setLatestCaptureId] = useState(null);

  // --- ENHANCED CAMERA FUNCTIONS ---
  const openCamera = async (target = "star") => {
    setActiveCameraTarget(target);
    setCapturedPhoto(null); // Reset preview on open
    setLatestCaptureId(null);

    try {
      const stream = await navigator.mediaDevices.getUserMedia({
        video: {
          facingMode: currentFacingMode,
          width: { ideal: 1280, min: 640 },
          height: { ideal: 720, min: 480 },
          frameRate: { ideal: 30 },
        },
        audio: false,
      });
      streamRef.current = stream;
      setShowCamera(true);

      setTimeout(() => {
        if (videoRef.current) {
          videoRef.current.srcObject = stream;
          videoRef.current.play().catch(console.error);
        }
      }, 150);

      const devices = await navigator.mediaDevices.enumerateDevices();
      setHasMultipleCameras(
        devices.filter((d) => d.kind === "videoinput").length > 1
      );
    } catch (err) {
      alert("Could not open camera: " + err.message);
    }
  };

  const switchCamera = async () => {
    const newMode = currentFacingMode === "user" ? "environment" : "user";
    if (streamRef.current) {
      streamRef.current.getTracks().forEach((track) => track.stop());
    }
    try {
      const stream = await navigator.mediaDevices.getUserMedia({
        video: {
          facingMode: newMode,
          width: { ideal: 1280, min: 640 },
          height: { ideal: 720, min: 480 },
          frameRate: { ideal: 30 },
        },
        audio: false,
      });
      streamRef.current = stream;
      setCurrentFacingMode(newMode);
      setTimeout(() => {
        if (videoRef.current) {
          videoRef.current.srcObject = stream;
          videoRef.current.play().catch(console.error);
        }
      }, 150);
    } catch (err) {
      alert("Could not switch camera: " + err.message);
    }
  };

  const closeCamera = () => {
    if (streamRef.current) {
      streamRef.current.getTracks().forEach((t) => t.stop());
    }
    setShowCamera(false);
    setCapturedPhoto(null);
  };

  const capturePhoto = () => {
    if (!videoRef.current) return;
    const canvas = document.createElement("canvas");
    canvas.width = videoRef.current.videoWidth || 1280;
    canvas.height = videoRef.current.videoHeight || 720;
    const ctx = canvas.getContext("2d");

    // MIRROR LOGIC: Flip canvas if using the front-facing (user) camera
    if (currentFacingMode === "user") {
      ctx.translate(canvas.width, 0);
      ctx.scale(-1, 1);
    }

    ctx.drawImage(videoRef.current, 0, 0);

    canvas.toBlob(
      (blob) => {
        const previewUrl = URL.createObjectURL(blob);
        let timestamp = null;

        // DYNAMIC TOGGLE CHECK: Uses the Star toggle or the Constellation toggle
        const shouldAddTimestamp =
          activeCameraTarget === "constellation" ? isStellaPost2 : isStellaPost;

        if (shouldAddTimestamp) {
          const now = new Date();
          timestamp = new Intl.DateTimeFormat("en-US", {
            hour: "numeric",
            minute: "2-digit",
            timeZoneName: "short",
            month: "long",
            day: "numeric",
            year: "numeric",
          })
            .format(now)
            .toLowerCase();
        }

        const newImage = {
          id: Date.now() + Math.random(),
          file: new File([blob], `camera-${Date.now()}.jpg`, {
            type: "image/jpeg",
          }),
          previewUrl,
          timestamp,
        };

        // Push photo to the correct sidebar array
        if (activeCameraTarget === "constellation") {
          setSelectedPhotos2((prev) => [...prev, newImage]);
        } else {
          setSelectedPhotos((prev) => [...prev, newImage]);
        }

        setLatestCaptureId(newImage.id);
        setCapturedPhoto(previewUrl); // Show preview instead of closing
      },
      "image/jpeg",
      0.95
    );
  };

  const handleRetake = () => {
    // Remove the photo we just added to the queue
    if (activeCameraTarget === "constellation") {
      setSelectedPhotos2((prev) =>
        prev.filter((img) => img.id !== latestCaptureId)
      );
    } else {
      setSelectedPhotos((prev) =>
        prev.filter((img) => img.id !== latestCaptureId)
      );
    }
    setLatestCaptureId(null);
    setCapturedPhoto(null); // Clear preview to show live video again
  };

  //   const closeCamera = () => {
  //     if (streamRef.current) {
  //       streamRef.current.getTracks().forEach((t) => t.stop());
  //     }
  //     setShowCamera(false);
  //   };

  //   const capturePhoto = () => {
  //     if (!videoRef.current) return;
  //     const canvas = document.createElement("canvas");
  //     canvas.width = videoRef.current.videoWidth || 1280;
  //     canvas.height = videoRef.current.videoHeight || 720;
  //     const ctx = canvas.getContext("2d");
  //     ctx.drawImage(videoRef.current, 0, 0);

  //     canvas.toBlob(
  //       (blob) => {
  //         const previewUrl = URL.createObjectURL(blob);
  //         let timestamp = null;

  //         if (isTimestampEnabled) {
  //           const now = new Date();
  //           timestamp = new Intl.DateTimeFormat("en-US", {
  //             hour: "numeric",
  //             minute: "2-digit",
  //             timeZoneName: "short",
  //             month: "long",
  //             day: "numeric",
  //             year: "numeric",
  //           })
  //             .format(now)
  //             .toLowerCase();
  //         }

  //         const newImage = {
  //           id: Date.now(),
  //           file: new File([blob], `camera-${Date.now()}.jpg`, {
  //             type: "image/jpeg",
  //           }),
  //           previewUrl,
  //           timestamp,
  //         };

  //         setSelectedPhotos((prev) => [...prev, newImage]);
  //         closeCamera(); // Closes after 1 shot. Adjust if you want burst mode.
  //       },
  //       "image/jpeg",
  //       0.95
  //     );
  //   };

  const handleFileChange = (e) => {
    const validFiles = Array.from(e.target.files).filter((f) =>
      f.type.startsWith("image/")
    );
    const newImages = validFiles.map((file) => ({
      id: Date.now() + Math.random(),
      file,
      previewUrl: URL.createObjectURL(file),
      timestamp: null, // File uploads don't get the live timestamp in this logic
    }));
    setSelectedPhotos((prev) => [...prev, ...newImages]);
  };

  const removePhoto = (id) => {
    setSelectedPhotos((prev) => prev.filter((p) => p.id !== id));
  };

  // ==========================================
  // EFFECTS & FETCHING
  // ==========================================

  useEffect(() => {
    // console.log("get parameters go ");
    const fetchData = async () => {
      try {
        const response = await axios.get(
          `${process.env.REACT_APP_BACKEND_URL}/zeusapolis/getUserByParameters/${UsernameUserID}`
        );
        setData(response.data.data);
      } catch (err) {
        console.error("Error fetching user data:", err);
      }
    };
    fetchData();

    //console.log("get parameters finished");
  }, [UsernameUserID]);

  useEffect(() => {
    const textArea = codeTextAreaRef.current;
    if (!textArea) return;

    const adjustHeight = () => {
      textArea.style.height = "auto";
      textArea.style.height = `${textArea.scrollHeight}px`;
      const lineCount = textArea.value.split("\n").length;
      const lineNumbers = Array.from(
        { length: lineCount },
        (_, i) => i + 1
      ).join("\n");
      if (textArea.previousSibling) {
        textArea.previousSibling.textContent = lineNumbers;
      }
    };

    textArea.addEventListener("input", adjustHeight);
    textArea.addEventListener("keydown", (e) => {
      if (e.key === "Enter") setTimeout(adjustHeight, 0);
    });

    adjustHeight();

    return () => {
      textArea.removeEventListener("input", adjustHeight);
      textArea.removeEventListener("keydown", adjustHeight);
    };
  }, [isCodeInput]);
  // ==========================================
  // HANDLERS (SVG DRAGGING - MOUSE & TOUCH)
  // ==========================================

  // --- MOUSE HANDLERS ---
  const handleMouseDown = (event) => {
    setDragging(true);
    setOffset({
      x: event.clientX - svgRef.current.getBoundingClientRect().left,
      y: event.clientY - svgRef.current.getBoundingClientRect().top,
    });
  };

  const handleMouseMove = (event) => {
    if (dragging) {
      const newX =
        event.clientX - svgRef.current.getBoundingClientRect().left - offset.x;
      const newY =
        event.clientY - svgRef.current.getBoundingClientRect().top - offset.y;

      setCircles((prev) =>
        prev.map((c) => ({ ...c, x: c.x + newX, y: c.y + newY }))
      );
      setOffset({
        x: event.clientX - svgRef.current.getBoundingClientRect().left,
        y: event.clientY - svgRef.current.getBoundingClientRect().top,
      });
    }
  };

  // --- TOUCH HANDLERS (For Mobile) ---
  const handleTouchStart = (event) => {
    setDragging(true);
    const touch = event.touches[0];
    setOffset({
      x: touch.clientX - svgRef.current.getBoundingClientRect().left,
      y: touch.clientY - svgRef.current.getBoundingClientRect().top,
    });
  };

  const handleTouchMove = (event) => {
    if (dragging) {
      event.preventDefault(); // Prevents the screen from pulling down while dragging
      const touch = event.touches[0];
      const newX =
        touch.clientX - svgRef.current.getBoundingClientRect().left - offset.x;
      const newY =
        touch.clientY - svgRef.current.getBoundingClientRect().top - offset.y;

      setCircles((prev) =>
        prev.map((c) => ({ ...c, x: c.x + newX, y: c.y + newY }))
      );
      setOffset({
        x: touch.clientX - svgRef.current.getBoundingClientRect().left,
        y: touch.clientY - svgRef.current.getBoundingClientRect().top,
      });
    }
  };

  // --- NEW: Second (Right) Sidebar States ---
  const [rightSidebarOpen, setRightSidebarOpen] = useState(false);
  const [newPostInput2, setNewPostInput2] = useState("");
  const [isStellaPost2, setIsStellaPost2] = useState(false);
  const [isHideStadia2, setIsHideStadia2] = useState(false);
  const [linkStatia2, setLinkStatia2] = useState([""]);
  const [mergeStatia2, setMergeStatia2] = useState([""]);
  const [selectedPhotos2, setSelectedPhotos2] = useState([]);

  const fileInputRef2 = useRef(null);

  // File handler for the second sidebar
  const handleFileChange2 = (e) => {
    const validFiles = Array.from(e.target.files).filter((f) =>
      f.type.startsWith("image/")
    );
    const newImages = validFiles.map((file) => ({
      id: Date.now() + Math.random(),
      file,
      previewUrl: URL.createObjectURL(file),
      timestamp: null,
    }));
    setSelectedPhotos2((prev) => [...prev, ...newImages]);
  };

  const removePhoto2 = (id) => {
    setSelectedPhotos2((prev) => prev.filter((p) => p.id !== id));
  };
  // -----------------------------------

  const handleTouchEnd = () => setDragging(false);

  // console.log("ocancerz console is loaded");

  const handleStarSubmit = async () => {
    if (!newPostInput.trim() || selectedPhotos.length === 0) {
      return; // Stops the submission
    }

    // console.log(auth.loginVar);
    // console.log("star function is go ");
    setIsSubmittingStar(true);
    try {
      const formData = new FormData();
      const imageTimestamps = selectedPhotos.map((img) => img.timestamp);

      const hello = ["lala", "lalabla", "weeoo", "totototo", "tctctc"];

      const postObjectforSubmital = {
        ocancerzText: newPostInput,
        tgridFile: isStellaPost,
        //isHideStadia,
        linkStatia: linkStatia.filter(Boolean), // Removes empty inputs ///// links are post ids , get post id , display post , add id
        // mergeStatia: mergeStatia.filter(Boolean),
        imageTimestamps,
      };
      // console.log(auth.loginVar);

      // Append Original Photos
      selectedPhotos.forEach((img) => {
        formData.append("StarPostImages", img.file);
      });

      // Append Data
      formData.append("userUsername", auth.loginVar);
      formData.append(
        "templeGridNormalPostData",
        JSON.stringify(postObjectforSubmital)
      );

      // console.log("star post running");
      // PLACEHOLDER API ROUTE - Update when ready
      await axios.post(
        `${process.env.REACT_APP_BACKEND_URL}/zeusapolis/ocancerz-metavz/createOcancerzoOSStarPost`,
        formData,
        {
          //withCredentials: true, // CRITICAL: Sends your new 100-year cookie
          onUploadProgress: (progressEvent) => {
            const percentCompleted = Math.round(
              (progressEvent.loaded * 100) / progressEvent.total
            );
            //console.log(`Upload Progress: ${percentCompleted}%`);
          },
        }
      );

      //console.log("star post stopped");

      alert("Star Post uploaded successfully!");
      clearStarForm();
    } catch (error) {
      console.error("Upload failed:", error);
      alert("Upload failed. Please try again.");
    } finally {
      setIsSubmittingStar(false);
    }

    // try {
    //   const [postsResponse, formsResponse] = await Promise.all([
    //     axios.get(
    //       `${process.env.REACT_APP_BACKEND_URL}/zeusapolis/ocancerz-metavz/getusertgOcancerStarPosts/${auth.loginVar}`
    //     ),
    //     axios.get(
    //       `${process.env.REACT_APP_BACKEND_URL}/zeusapolis/ocancerz-metavz/getusertgOcancerStarForms/${auth.loginVar}`
    //     ),
    //   ]);

    //   settheOcancerStarPosts(postsResponse.data.data.functionGo);
    //   settheOcancerStarForms(formsResponse.data.data.functionGo);
    // } catch (err) {
    //   console.error("Failed to load Ocancerz posts", err);
    // }

    // console.log("starting");
    // console.log(
    //   "user logged in verification , userProfileposts Container vvv"
    // );
    // console.log(auth);
    // console.log(auth.loginVar);
    // console.log(auth.loginVar.tokenLoginData);
    try {
      //setLoading(true);
      const response = await axios.get(
        `${process.env.REACT_APP_BACKEND_URL}/zeusapolis/ocancerz-metavz/getusertgOcancerStarPosts/${auth.loginVar}`
      ); // Example API endpoint
      // console.log(response.data.data[0]);
      // console.log(response.data.data[0].username);
      settheOcancerStarPosts(response.data.data.functionGo);
      // console.log(response.data.data);
      // console.log(response.data.data.templeGrid_PhotoVault);
    } catch (err) {
      // setError(err.message);
    } finally {
      // setLoading(false);
    }
  };

  const handleConstellationSubmit = async () => {
    if (!newPostInput2.trim() && selectedPhotos2.length === 0) {
      // console.log("not working , trim");
      return; // Stops the submission
    }
    setIsSubmittingConstellation(true);
    try {
      const formData = new FormData();
      const imageTimestamps = selectedPhotos2.map((img) => img.timestamp);

      //console.log(mergeStatia2);
      const cleanMergeIds = mergeStatia2.filter((id) => id.trim() !== "");

      // console.log("here's the clean ids vvvv");
      // console.log(cleanLinkIds);
      //console.log(cleanMergeIds);
      const postObjectforSubmital = {
        ocancerzStarFormText: newPostInput2,
        tgridFile: isStellaPost2,
        // isHideStadia: isHideStadia2,
        // linkStatia: linkStatia2.filter(Boolean),
        starsinConstellation: cleanMergeIds,
        imageTimestamps,
      };

      // Append Original Photos
      selectedPhotos2.forEach((img) => {
        formData.append("StarFormsImages", img.file);
      });

      // Append Data
      formData.append("userUsername", auth.loginVar);
      formData.append(
        "templeGridNormalPostData",
        JSON.stringify(postObjectforSubmital)
      );

      // PLACEHOLDER API ROUTE - Update when ready
      await axios.post(
        `${process.env.REACT_APP_BACKEND_URL}/zeusapolis/ocancerz-metavz/createOcancerzoOSStarFormStatia`,
        formData
      );

      alert("Constellation Post uploaded successfully!");
      clearConstellationForm();
    } catch (error) {
      console.error("Upload failed:", error);
      alert("Upload failed. Please try again.");
    } finally {
      setIsSubmittingConstellation(false);
    }

    // console.log("starting");
    // console.log(
    //   "user logged in verification , userProfileposts Container vvv"
    // );
    // console.log(auth);
    // console.log(auth.loginVar);
    // console.log(auth.loginVar.tokenLoginData);
    try {
      //setLoading(true);
      const response = await axios.get(
        `${process.env.REACT_APP_BACKEND_URL}/zeusapolis/ocancerz-metavz/getusertgOcancerStarForms/${auth.loginVar}`
      ); // Example API endpoint
      // console.log(response.data.data[0]);
      // console.log(response.data.data[0].username);
      settheOcancerStarForms(response.data.data.functionGo);
      //console.log(response.data.data);
      // console.log(response.data.data.templeGrid_PhotoVault);
    } catch (err) {
      // setError(err.message);
    } finally {
      // setLoading(false);
    }
  };

  // --- BIND EVENT LISTENERS ---
  useEffect(() => {
    document.addEventListener("mousemove", handleMouseMove);
    document.addEventListener("mouseup", handleMouseUp);

    // { passive: false } allows us to use event.preventDefault() to stop screen scrolling
    document.addEventListener("touchmove", handleTouchMove, { passive: false });
    document.addEventListener("touchend", handleTouchEnd);

    return () => {
      document.removeEventListener("mousemove", handleMouseMove);
      document.removeEventListener("mouseup", handleMouseUp);
      document.removeEventListener("touchmove", handleTouchMove);
      document.removeEventListener("touchend", handleTouchEnd);
    };
  }, [dragging, offset]);

  const handleMouseUp = () => {
    setDragging(false);
  };

  // 3. RESET CIRCLES HANDLER
  const resetCircles = () => {
    setCircles(circleData);
  };

  // ==========================================
  // RENDER
  // ==========================================

  return (
    <div className="templegrid">
      <div className=""></div>

      <div>
        <div className="testamentArk1John15-templeCatwalk">
          <div className="testamentArk1John15-templeCatwalk">
            <div className="aquariam">
              <button
                onClick={() => setViewMode("const")}
                className="aquariam-button"
              >
                Ocancerz
              </button>
              <button
                onClick={() => setViewMode("grid")}
                className="aquariam-button"
              >
                Grid
              </button>
            </div>
          </div>

          <div className="testamentArk1John15-porch">
            <div style={{ display: "flex", gap: "15px", marginBottom: "20px" }}>
              {[].map((tab) => (
                <div
                  key={tab}
                  onClick={() => setActiveTab(tab)}
                  className="testamentArk1John15-blobBlades"
                  style={{
                    cursor: "pointer",
                    fontWeight: activeTab === tab ? "bold" : "normal",
                  }}
                >
                  hello
                  {tab.charAt(0).toUpperCase() +
                    tab.slice(1).replace(/([A-Z])/g, " $1")}
                  {activeTab === tab && (
                    <hr
                      style={{
                        border: "none",
                        height: "1px",
                        background:
                          "linear-gradient(to right, rgba(255,255,255,0), rgba(255,255,255,1), rgba(255,255,255,0))",
                      }}
                    />
                  )}
                </div>
              ))}
            </div>

            {/* View Mode: Const / Ocancerz SVG Interface */}
            {viewMode === "const" && (
              <div style={{ marginTop: "20px" }}>
                <div
                  style={{
                    display: "flex",
                    flexWrap: "wrap",
                    gap: "10px",
                    marginBottom: "15px",
                  }}
                >
                  {/* 🌟 NEW: Added 'currents' and 'space' to the panel array */}
                  {[
                    "eternity",
                    "void",
                    "sanctuary",
                    "home",
                    "skyline",
                    "catacombs",
                    "currents",
                    "space",
                  ].map((panel) => (
                    <button
                      key={panel}
                      onClick={() => setActivePanel(panel)}
                      style={{
                        padding: "8px 16px",
                        background:
                          activePanel === panel
                            ? "#7b00ff"
                            : "rgba(255,255,255,0.1)",
                        color: "white",
                        border: "1px solid #7b00ff",
                        borderRadius: "4px",
                        cursor: "pointer",
                        textTransform: "capitalize",
                      }}
                    >
                      {panel}
                    </button>
                  ))}
                </div>

                <div
                  style={{
                    marginBottom: "15px",
                    fontStyle: "italic",
                    color: "#ccc",
                  }}
                >
                  {/* Panel specific text can go here */}
                </div>

                <div
                  className={`ocancerz-canvas-wrapper ${
                    isFullscreen ? "fullscreen-mode" : ""
                  }`}
                >
                  {/* Left Controls (Top Left) */}
                  <div
                    style={{
                      position: "absolute",
                      top: "15px",
                      left: "15px",
                      zIndex: 100,
                    }}
                  >
                    <button
                      onClick={() => setLeftSidebarOpen(!leftSidebarOpen)}
                      className="ocancerz-control-btn primary"
                    >
                      ☰ Star
                    </button>
                  </div>

                  {/* Right Controls (Top Right) */}

                  {/* Right Controls (Top Right) */}

                  {/* Right Controls (Top Right) */}
                  <div className="ocancerz-top-right-controls">
                    <button
                      onClick={() => setRightSidebarOpen(!rightSidebarOpen)}
                      className="ocancerz-control-btn primary"
                    >
                      ☰ Constellations
                    </button>
                    <button
                      onClick={handleZoomOut}
                      className="ocancerz-control-btn"
                    >
                      -
                    </button>
                    <button
                      onClick={handleZoomIn}
                      className="ocancerz-control-btn"
                    >
                      +
                    </button>

                    {/* 🌟 THE FIX: Made the wrapper "relative" and the Rights button "absolute" so siblings don't stretch! */}
                    <div
                      style={{ position: "relative", display: "inline-block" }}
                    >
                      <button
                        onClick={resetCircles}
                        className="ocancerz-control-btn"
                        style={{ width: "100%" }}
                      >
                        Home
                      </button>
                      <button
                        onClick={() =>
                          setIsBillOfRightsOpen(!isBillOfRightsOpen)
                        }
                        className="ocancerz-control-btn"
                        style={{
                          position: "absolute",
                          top: "100%",
                          left: 0,
                          width: "100%",
                          marginTop: "6px",
                          fontSize: "0.75rem",
                          padding: "4px 0",
                        }}
                      >
                        📜 Rights
                      </button>
                    </div>

                    <button
                      onClick={() => setIsFullscreen(!isFullscreen)}
                      className="ocancerz-control-btn"
                    >
                      {isFullscreen ? "⤧" : "⤡"}
                    </button>
                  </div>

                  {/* Conditionally Rendered 'Hell' Button for Void Panel (Bottom Left) */}
                  {activePanel === "void" && (
                    <button
                      style={{
                        position: "absolute",
                        bottom: "15px",
                        left: "15px",
                        zIndex: 100,
                        background: "rgba(255, 0, 0, 0.15)",
                        color: "#ff4444",
                        border: "1px solid rgba(255, 0, 0, 0.5)",
                        padding: "6px 16px",
                        borderRadius: "6px",
                        cursor: "pointer",
                        fontWeight: "bold",
                        fontSize: "0.85rem",
                        backdropFilter: "blur(4px)",
                      }}
                      onClick={() => console.log("Hell interface opened")}
                    >
                      Hell
                    </button>
                  )}
                  {/* 🌟 NEW: The Home Archive Sidebar */}
                  {activePanel === "home" && (
                    <aside
                      style={{
                        position: "absolute",
                        top: "70px",
                        left: "15px",
                        width: "320px",
                        background: "white",
                        borderRadius: "8px",
                        zIndex: 90,
                        height: "calc(100% - 90px)",
                        overflowY: "auto",
                        padding: "15px",
                        boxShadow: "0 4px 12px rgba(0,0,0,0.15)",
                      }}
                    >
                      <h3
                        style={{
                          marginTop: 0,
                          color: "#00008b",
                          borderBottom: "2px solid #eee",
                          paddingBottom: "10px",
                        }}
                      >
                        Archives
                      </h3>

                      {/* Toggle Tabs */}
                      <div
                        style={{
                          display: "flex",
                          gap: "10px",
                          marginBottom: "20px",
                        }}
                      >
                        <button
                          onClick={() => setHomeTab("stars")}
                          style={{
                            flex: 1,
                            padding: "8px",
                            background:
                              homeTab === "stars" ? "#7b00ff" : "#f0f0f0",
                            color: homeTab === "stars" ? "white" : "#555",
                            fontWeight: "bold",
                            border: "none",
                            borderRadius: "4px",
                            cursor: "pointer",
                          }}
                        >
                          Stars
                        </button>
                        <button
                          onClick={() => setHomeTab("constellations")}
                          style={{
                            flex: 1,
                            padding: "8px",
                            background:
                              homeTab === "constellations"
                                ? "#7b00ff"
                                : "#f0f0f0",
                            color:
                              homeTab === "constellations" ? "white" : "#555",
                            fontWeight: "bold",
                            border: "none",
                            borderRadius: "4px",
                            cursor: "pointer",
                          }}
                        >
                          Constellations
                        </button>
                      </div>
                      {/* Render Grouped Dates (Sorted Newest First) */}
                      {Object.keys(groupedHomeData).length === 0 ? (
                        <div
                          style={{
                            textAlign: "center",
                            color: "#888",
                            marginTop: "20px",
                          }}
                        >
                          No posts yet.
                        </div>
                      ) : (
                        Object.keys(groupedHomeData)
                          .sort((a, b) => new Date(b) - new Date(a)) // 🌟 Sorts dates descending
                          .map((dateLabel) => (
                            <div
                              key={dateLabel}
                              style={{ marginBottom: "20px" }}
                            >
                              {/* The Date Header */}
                              <div
                                style={{
                                  background: "#f8f8f8",
                                  padding: "6px 12px",
                                  borderRadius: "4px",
                                  fontWeight: "bold",
                                  fontSize: "0.8rem",
                                  color: "#00008b",
                                  marginBottom: "15px",
                                  letterSpacing: "1px",
                                }}
                              >
                                {dateLabel}
                              </div>

                              {/* The Posts inside that Date (Reversed so newest is top) */}
                              {/* The Posts inside that Date (Reversed so newest is top) */}
                              {groupedHomeData[dateLabel]
                                .slice()
                                .reverse()
                                .map((post, idx) => {
                                  // Resolve a safe key depending on if it's an object or a string ID
                                  const safeKey =
                                    typeof post === "object"
                                      ? post.uid || post._id
                                      : post;

                                  return (
                                    <div
                                      key={safeKey || idx} // <--- USE THE RESOLVED KEY
                                      style={{
                                        marginBottom: "15px",
                                        transform: "scale(0.95)",
                                        transformOrigin: "top center",
                                      }}
                                    >
                                      {homeTab === "stars" ? (
                                        <OcancerzStarszPostItems
                                          postFunction={post}
                                          isPreviewMode={true}
                                          onEditPost={setEditingPost}
                                        />
                                      ) : (
                                        <OcancerzStarFormItems
                                          postFunction={post}
                                          isPreviewMode={true}
                                          onEditPost={setEditingPost}
                                        />
                                      )}
                                    </div>
                                  );
                                })}
                            </div>
                          ))
                      )}
                      {/* 🌟 NEW: Smooth Vector Glowing Cancer Icon in Top Right */}
                    </aside>
                  )}
                  {/* 🌟 NEW: Glowing Icon appears ONLY when Home tab is active, positioned below the right controls */}
                  {/* 🌟 NEW: Glowing Icon & Petition Button (Only on Home Panel) */}
                  {activePanel === "home" && (
                    <div
                      style={{
                        position: "absolute",
                        top: "75px",
                        right: "25px",
                        zIndex: 100,
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                        gap: "10px", // Spacing between icon and button
                      }}
                    >
                      <div style={{ pointerEvents: "none" }}>
                        <svg
                          width="48"
                          height="48"
                          viewBox="0 0 24 24"
                          style={{
                            filter:
                              "drop-shadow(0 0 3px #ff00ff) drop-shadow(0 0 10px #cc00ff) drop-shadow(0 0 20px rgba(204, 0, 255, 0.8))",
                            overflow: "visible",
                          }}
                        >
                          <g
                            fill="none"
                            stroke="#ffffff"
                            strokeWidth="2.5"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          >
                            <path d="M 18 9 C 16 4.5, 12 3.5, 7 5 A 3 3 0 1 0 7 11 A 3 3 0 0 0 7 5" />
                            <path d="M 6 15 C 8 19.5, 12 20.5, 17 19 A 3 3 0 1 0 17 13 A 3 3 0 0 0 17 19" />
                          </g>
                        </svg>
                      </div>

                      {/* 🌟 NEW: Petition Tab Button */}
                      <button
                        onClick={() => console.log("Petition clicked")}
                        style={{
                          background: "rgba(255, 0, 255, 0.15)",
                          border: "1px solid #ff00ff",
                          color: "#ff00ff",
                          padding: "6px 14px",
                          borderRadius: "10px",
                          fontWeight: "bold",
                          cursor: "pointer",
                          boxShadow: "0 0 10px rgba(204, 0, 255, 0.3)",
                          backdropFilter: "blur(4px)",
                          textTransform: "uppercase",
                          fontSize: "0.7rem",
                          letterSpacing: "1px",
                          transition: "all 0.2s",
                        }}
                        onMouseOver={(e) =>
                          (e.currentTarget.style.background =
                            "rgba(255, 0, 255, 0.3)")
                        }
                        onMouseOut={(e) =>
                          (e.currentTarget.style.background =
                            "rgba(255, 0, 255, 0.15)")
                        }
                      >
                        Petition
                      </button>
                    </div>
                  )}
                  {/* 🌟 NEW: Floating Bill of Rights Tab (Right Side) */}
                  {isBillOfRightsOpen && (
                    <aside className="ocancerz-floating-panel">
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "space-between",
                          alignItems: "center",
                          borderBottom: "2px solid #eee",
                          paddingBottom: "10px",
                          marginBottom: "15px",
                        }}
                      >
                        <h3 style={{ margin: 0, color: "#00008b" }}>
                          U.S. Bill of Rights
                        </h3>
                        <button
                          onClick={() => setIsBillOfRightsOpen(false)}
                          style={{
                            background: "none",
                            border: "none",
                            fontSize: "1.2rem",
                            cursor: "pointer",
                            color: "#888",
                          }}
                        >
                          ✖
                        </button>
                      </div>

                      <div
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          gap: "16px",
                          fontSize: "0.85rem",
                          lineHeight: "1.6",
                          color: "#333",
                        }}
                      >
                        <div
                          style={{
                            borderBottom: "1px solid #ddd",
                            padding: "0 20px 16px",
                            margin: "0 -20px",
                          }}
                        >
                          <strong style={{ color: "#00008b" }}>
                            1. First Amendment
                          </strong>
                          <br />
                          Congress shall make no law respecting an establishment
                          of religion, or prohibiting the free exercise thereof;
                          or abridging the freedom of speech, or of the press;
                          or the right of the people peaceably to assemble, and
                          to petition the Government for a redress of
                          grievances.
                        </div>
                        <div
                          style={{
                            borderBottom: "1px solid #ddd",
                            padding: "0 20px 16px",
                            margin: "0 -20px",
                          }}
                        >
                          <strong style={{ color: "#00008b" }}>
                            2. Second Amendment
                          </strong>
                          <br />A well regulated Militia, being necessary to the
                          security of a free State, the right of the people to
                          keep and bear Arms, shall not be infringed.
                        </div>
                        <div
                          style={{
                            borderBottom: "1px solid #ddd",
                            padding: "0 20px 16px",
                            margin: "0 -20px",
                          }}
                        >
                          <strong style={{ color: "#00008b" }}>
                            3. Third Amendment
                          </strong>
                          <br />
                          No Soldier shall, in time of peace be quartered in any
                          house, without the consent of the Owner, nor in time
                          of war, but in a manner to be prescribed by law.
                        </div>
                        <div
                          style={{
                            borderBottom: "1px solid #ddd",
                            padding: "0 20px 16px",
                            margin: "0 -20px",
                          }}
                        >
                          <strong style={{ color: "#00008b" }}>
                            4. Fourth Amendment
                          </strong>
                          <br />
                          The right of the people to be secure in their persons,
                          houses, papers, and effects, against unreasonable
                          searches and seizures, shall not be violated, and no
                          Warrants shall issue, but upon probable cause,
                          supported by Oath or affirmation, and particularly
                          describing the place to be searched, and the persons
                          or things to be seized.
                        </div>
                        <div
                          style={{
                            borderBottom: "1px solid #ddd",
                            padding: "0 20px 16px",
                            margin: "0 -20px",
                          }}
                        >
                          <strong style={{ color: "#00008b" }}>
                            5. Fifth Amendment
                          </strong>
                          <br />
                          No person shall be held to answer for a capital, or
                          otherwise infamous crime, unless on a presentment or
                          indictment of a Grand Jury... nor shall any person be
                          subject for the same offence to be twice put in
                          jeopardy of life or limb; nor shall be compelled in
                          any criminal case to be a witness against himself, nor
                          be deprived of life, liberty, or property, without due
                          process of law; nor shall private property be taken
                          for public use, without just compensation.
                        </div>
                        <div
                          style={{
                            borderBottom: "1px solid #ddd",
                            padding: "0 20px 16px",
                            margin: "0 -20px",
                          }}
                        >
                          <strong style={{ color: "#00008b" }}>
                            6. Sixth Amendment
                          </strong>
                          <br />
                          In all criminal prosecutions, the accused shall enjoy
                          the right to a speedy and public trial, by an
                          impartial jury of the State and district wherein the
                          crime shall have been committed... and to have the
                          Assistance of Counsel for his defence.
                        </div>
                        <div
                          style={{
                            borderBottom: "1px solid #ddd",
                            padding: "0 20px 16px",
                            margin: "0 -20px",
                          }}
                        >
                          <strong style={{ color: "#00008b" }}>
                            7. Seventh Amendment
                          </strong>
                          <br />
                          In Suits at common law, where the value in controversy
                          shall exceed twenty dollars, the right of trial by
                          jury shall be preserved...
                        </div>
                        <div
                          style={{
                            borderBottom: "1px solid #ddd",
                            padding: "0 20px 16px",
                            margin: "0 -20px",
                          }}
                        >
                          <strong style={{ color: "#00008b" }}>
                            8. Eighth Amendment
                          </strong>
                          <br />
                          Excessive bail shall not be required, nor excessive
                          fines imposed, nor cruel and unusual punishments
                          inflicted.
                        </div>
                        <div
                          style={{
                            borderBottom: "1px solid #ddd",
                            padding: "0 20px 16px",
                            margin: "0 -20px",
                          }}
                        >
                          <strong style={{ color: "#00008b" }}>
                            9. Ninth Amendment
                          </strong>
                          <br />
                          The enumeration in the Constitution, of certain
                          rights, shall not be construed to deny or disparage
                          others retained by the people.
                        </div>
                        <div
                          style={{ padding: "0 20px 4px", margin: "0 -20px" }}
                        >
                          <strong style={{ color: "#00008b" }}>
                            10. Tenth Amendment
                          </strong>
                          <br />
                          The powers not delegated to the United States by the
                          Constitution, nor prohibited by it to the States, are
                          reserved to the States respectively, or to the people.
                        </div>
                      </div>
                    </aside>
                  )}
                  {/* 🌟 NEW: Currents / News Floating Panel (Styled like the Rights Tab) */}
                  {activePanel === "currents" && (
                    <aside className="ocancerz-floating-panel">
                      <h3
                        style={{
                          margin: "0 0 15px 0",
                          color: "#00008b",
                          borderBottom: "2px solid #eee",
                          paddingBottom: "10px",
                          textAlign: "center",
                          letterSpacing: "2px",
                          textTransform: "uppercase",
                        }}
                      >
                        News
                      </h3>

                      {/* Currents Sub-Tabs (2x2 Grid) */}
                      <div
                        style={{
                          display: "flex",
                          flexWrap: "wrap",
                          gap: "8px",
                          marginBottom: "20px",
                        }}
                      >
                        {[
                          "Electricity",
                          "Star Oceans",
                          "Metal",
                          "Violence",
                        ].map((tab) => (
                          <button
                            key={tab}
                            onClick={() => setCurrentsTab(tab)}
                            style={{
                              flex: "1 1 calc(50% - 8px)", // Neatly divides them into two columns
                              padding: "8px",
                              background:
                                currentsTab === tab ? "#7b00ff" : "#f0f0f0",
                              color: currentsTab === tab ? "white" : "#555",
                              fontWeight: "bold",
                              border: "none",
                              borderRadius: "4px",
                              cursor: "pointer",
                              fontSize: "0.8rem",
                            }}
                          >
                            {tab}
                          </button>
                        ))}
                      </div>

                      {/* Content Area for the Selected News Tab */}
                      <div
                        style={{
                          color: "#333",
                          fontSize: "0.9rem",
                          lineHeight: "1.5",
                          padding: "10px 0",
                        }}
                      >
                        <div
                          style={{
                            textAlign: "center",
                            color: "#888",
                            fontStyle: "italic",
                            marginTop: "20px",
                          }}
                        >
                          Viewing latest updates for:{" "}
                          <strong style={{ color: "#7b00ff" }}>
                            {currentsTab}
                          </strong>
                        </div>
                      </div>
                    </aside>
                  )}
                  {/* 🌟 NEW: Catacombs Floating Panel */}
                  {activePanel === "catacombs" && (
                    <aside className="ocancerz-floating-panel">
                      <h3
                        style={{
                          margin: "0 0 15px 0",
                          color: "#00008b",
                          borderBottom: "2px solid #eee",
                          paddingBottom: "10px",
                          textAlign: "center",
                          letterSpacing: "2px",
                          textTransform: "uppercase",
                        }}
                      >
                        Catacombs
                      </h3>

                      {/* Catacombs Sub-Tabs */}
                      <div
                        style={{
                          display: "flex",
                          gap: "10px",
                          marginBottom: "20px",
                        }}
                      >
                        {["Dead zones", "Criminals"].map((tab) => (
                          <button
                            key={tab}
                            onClick={() => setCatacombsTab(tab)}
                            style={{
                              flex: 1, // Stretches both buttons evenly across the container
                              padding: "8px",
                              background:
                                catacombsTab === tab ? "#7b00ff" : "#f0f0f0",
                              color: catacombsTab === tab ? "white" : "#555",
                              fontWeight: "bold",
                              border: "none",
                              borderRadius: "4px",
                              cursor: "pointer",
                              fontSize: "0.85rem",
                            }}
                          >
                            {tab}
                          </button>
                        ))}
                      </div>

                      {/* Content Area for the Selected Catacombs Tab */}
                      <div
                        style={{
                          color: "#333",
                          fontSize: "0.9rem",
                          lineHeight: "1.5",
                          padding: "10px 0",
                        }}
                      >
                        <div
                          style={{
                            textAlign: "center",
                            color: "#888",
                            fontStyle: "italic",
                            marginTop: "20px",
                          }}
                        >
                          {" "}
                          <strong style={{ color: "#7b00ff" }}>
                            {catacombsTab}
                          </strong>
                        </div>
                      </div>
                    </aside>
                  )}

                  {/* Left Sidebar Content */}
                  <aside
                    className={`ocancerz-left-sidebar ${
                      leftSidebarOpen ? "open" : ""
                    }`}
                  >
                    <div>
                      <div
                        className="post-input-container"
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          gap: "10px",
                        }}
                      >
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center",
                          }}
                        >
                          <h3 style={{ margin: "0 0 10px 0" }}>Stars</h3>
                          {/* Handy Mobile Close Button */}
                          <button
                            className="mobile-close-btn"
                            onClick={() => setLeftSidebarOpen(false)}
                          >
                            ✖
                          </button>
                        </div>

                        {/* Stella Toggle */}
                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "space-between",
                            background: "#f0f0f0",
                            padding: "10px",
                            borderRadius: "4px",
                          }}
                        >
                          <span style={{ fontWeight: "bold" }}>Star</span>
                          <button
                            type="button"
                            onClick={() => setIsStellaPost(!isStellaPost)}
                            style={{
                              background: isStellaPost ? "#7b00ff" : "#ccc",
                              border: "none",
                              padding: "5px 15px",
                              borderRadius: "15px",
                              color: "white",
                              cursor: "pointer",
                              transition: "background 0.3s",
                            }}
                          >
                            tgrid
                          </button>
                        </div>

                        {/* Main Text Input */}
                        <textarea
                          value={newPostInput}
                          onChange={(e) => setNewPostInput(e.target.value)}
                          placeholder="A Star..."
                          rows={3}
                          style={{
                            width: "100%",
                            padding: "10px",
                            borderRadius: "4px",
                            border: "1px solid #ccc",
                            background: "white",
                            color: "#00008b",
                            resize: "vertical",
                            boxSizing: "border-box",
                          }}
                        />
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "flex-end",
                            marginTop: "4px",
                            marginBottom: "-4px",
                          }}
                        >
                          <button
                            type="button"
                            onClick={() =>
                              setIsOcancerzSignActive(!isOcancerzSignActive)
                            }
                            style={{
                              background: "transparent",
                              border: "none",
                              cursor: "pointer",
                              padding: "0",
                              display: "flex",
                              outline: "none", // Removes the blue focus highlight on desktop
                              WebkitTapHighlightColor: "transparent", // Removes the tap highlight on mobile
                            }}
                          >
                            <svg
                              width="24"
                              height="24"
                              viewBox="0 0 24 24"
                              style={{
                                filter:
                                  "drop-shadow(0 0 2px #ff00ff) drop-shadow(0 0 5px #cc00ff)", // Keeps the glow static
                                overflow: "visible",
                              }}
                            >
                              <g
                                fill="none"
                                stroke={
                                  isOcancerzSignActive ? "#4c00ff" : "#ffffff"
                                }
                                strokeWidth="2.5"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                style={{ transition: "stroke 0.2s ease" }}
                              >
                                <path d="M 18 9 C 16 4.5, 12 3.5, 7 5 A 3 3 0 1 0 7 11 A 3 3 0 0 0 7 5" />
                                <path d="M 6 15 C 8 19.5, 12 20.5, 17 19 A 3 3 0 1 0 17 13 A 3 3 0 0 0 17 19" />
                              </g>
                            </svg>
                          </button>
                        </div>

                        {/* Photo Controls */}
                        <div
                          style={{
                            display: "flex",
                            gap: "10px",
                            justifyContent: "space-between",
                            marginTop: "10px",
                          }}
                        >
                          <button
                            type="button"
                            onClick={() => fileInputRef.current?.click()}
                            className="ocancerz-control-btn"
                          >
                            🖼️ Photos
                          </button>
                          <button
                            type="button"
                            onClick={() => openCamera("star")}
                            className="ocancerz-control-btn"
                          >
                            📸 Camera
                          </button>
                          <input
                            ref={fileInputRef}
                            type="file"
                            accept="image/*"
                            multiple
                            onChange={handleFileChange}
                            style={{ display: "none" }}
                          />
                        </div>

                        {/* Photo Previews */}
                        {selectedPhotos.length > 0 && (
                          <div
                            style={{
                              display: "flex",
                              gap: "10px",
                              overflowX: "auto",
                              padding: "5px 0 20px 0",
                            }}
                          >
                            {selectedPhotos.map((photo) => (
                              <div
                                key={photo.id}
                                style={{
                                  position: "relative",
                                  minWidth: "60px",
                                  display: "flex",
                                  flexDirection: "column",
                                  alignItems: "center",
                                }}
                              >
                                <img
                                  src={photo.previewUrl}
                                  alt="preview"
                                  style={{
                                    width: "60px",
                                    height: "60px",
                                    objectFit: "cover",
                                    borderRadius: "4px",
                                  }}
                                />
                                <button
                                  onClick={() => removePhoto(photo.id)}
                                  style={{
                                    position: "absolute",
                                    top: -5,
                                    right: -5,
                                    background: "red",
                                    color: "white",
                                    border: "none",
                                    borderRadius: "50%",
                                    width: "20px",
                                    height: "20px",
                                    cursor: "pointer",
                                    fontSize: "12px",
                                  }}
                                >
                                  ×
                                </button>
                                {photo.timestamp && (
                                  <div
                                    style={{
                                      fontSize: "9px",
                                      color: "#888",
                                      marginTop: "4px",
                                      textAlign: "center",
                                      width: "80px",
                                      wordWrap: "break-word",
                                    }}
                                  >
                                    {photo.timestamp.split(",")[0]}
                                  </div>
                                )}
                              </div>
                            ))}
                          </div>
                        )}

                        {/* Post Button */}
                        {auth.isLoggedIn && (
                          <button
                            onClick={handleStarSubmit}
                            disabled={isSubmittingStar}
                            style={{
                              background: "#00008b",
                              color: "white",
                              border: "none",
                              padding: "10px",
                              borderRadius: "4px",
                              cursor: isSubmittingStar
                                ? "not-allowed"
                                : "pointer",
                              fontWeight: "bold",
                              marginTop: "15px",
                              opacity: isSubmittingStar ? 0.7 : 1,
                            }}
                          >
                            {isSubmittingStar
                              ? "Posting..."
                              : `Star ${isStellaPost ? "tgrid" : ""}`}
                          </button>
                        )}
                      </div>

                      {theOcancerStarPosts && (
                        <OcancerzStarzPostList
                          // onEditPost={props.onEditPost}
                          postFunction={theOcancerStarPosts}
                          onMergeClick={handleAddPostToMergeStar}
                          refreshFeed={refreshFeed}
                          onEditPost={setEditingPost}
                        />
                      )}
                    </div>
                  </aside>

                  {/* Second (Right) Sidebar Content */}
                  <aside
                    className={`ocancerz-right-sidebar ${
                      rightSidebarOpen ? "open" : ""
                    }`}
                  >
                    <div
                      className="post-input-container"
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        gap: "10px",
                      }}
                    >
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "space-between",
                          alignItems: "center",
                        }}
                      >
                        <h3 style={{ margin: "0 0 10px 0" }}>Constellations</h3>
                        {/* Handy Mobile Close Button */}
                        <button
                          className="mobile-close-btn"
                          onClick={() => setRightSidebarOpen(false)}
                        >
                          ✖
                        </button>
                      </div>

                      {/* Stella Toggle 2 */}
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "space-between",
                          background: "#f0f0f0",
                          padding: "10px",
                          borderRadius: "4px",
                        }}
                      >
                        <span style={{ fontWeight: "bold" }}>
                          Constellation
                        </span>
                        <button
                          onClick={() => setIsStellaPost2(!isStellaPost2)}
                          style={{
                            background: isStellaPost2 ? "#7b00ff" : "#ccc",
                            border: "none",
                            padding: "5px 15px",
                            borderRadius: "15px",
                            color: "white",
                            cursor: "pointer",
                            transition: "background 0.3s",
                          }}
                        >
                          tgrid
                        </button>
                      </div>

                      {/* Main Text Input 2 */}
                      <textarea
                        value={newPostInput2}
                        onChange={(e) => setNewPostInput2(e.target.value)}
                        placeholder="Wow..."
                        rows={3}
                        style={{
                          width: "100%",
                          padding: "10px",
                          borderRadius: "4px",
                          border: "1px solid #ccc",
                          background: "white",
                          color: "#00008b",
                          resize: "vertical",
                          boxSizing: "border-box",
                        }}
                      />
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "flex-end",
                          marginTop: "4px",
                          marginBottom: "-4px",
                        }}
                      >
                        <button
                          type="button"
                          onClick={() =>
                            setIsOcancerzSignActive2(!isOcancerzSignActive2)
                          }
                          style={{
                            background: "transparent",
                            border: "none",
                            cursor: "pointer",
                            padding: "0",
                            display: "flex",
                            outline: "none",
                            WebkitTapHighlightColor: "transparent",
                          }}
                        >
                          <svg
                            width="24"
                            height="24"
                            viewBox="0 0 24 24"
                            style={{
                              filter:
                                "drop-shadow(0 0 2px #ff00ff) drop-shadow(0 0 5px #cc00ff)",
                              overflow: "visible",
                            }}
                          >
                            <g
                              fill="none"
                              stroke={
                                isOcancerzSignActive2 ? "#4c00ff" : "#ffffff"
                              }
                              strokeWidth="2.5"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              style={{ transition: "stroke 0.2s ease" }}
                            >
                              <path d="M 18 9 C 16 4.5, 12 3.5, 7 5 A 3 3 0 1 0 7 11 A 3 3 0 0 0 7 5" />
                              <path d="M 6 15 C 8 19.5, 12 20.5, 17 19 A 3 3 0 1 0 17 13 A 3 3 0 0 0 17 19" />
                            </g>
                          </svg>
                        </button>
                      </div>

                      {/* Dynamic Merge Statia Array 2 */}
                      <div style={{ fontWeight: "bold", marginTop: "5px" }}>
                        Stars
                      </div>
                      {mergeStatia2.map((val, i) => (
                        <div
                          key={`merge2-container-${i}`}
                          style={{ marginBottom: "10px" }}
                        >
                          <input
                            type="hidden"
                            value={val}
                            onChange={(e) =>
                              updateArrayInput(
                                setMergeStatia2,
                                i,
                                e.target.value
                              )
                            }
                          />
                          {val && val.trim() !== "" && (
                            <div
                              style={{
                                border: "2px dashed #7b00ff",
                                borderRadius: "6px",
                                padding: "5px",
                                background: "#f8f8f8",
                                transform: "scale(0.9)",
                                transformOrigin: "top center",
                              }}
                            >
                              <div
                                style={{
                                  fontSize: "10px",
                                  color: "#7b00ff",
                                  fontWeight: "bold",
                                  textAlign: "center",
                                  marginBottom: "5px",
                                }}
                              >
                                🔗 Merged Post Preview
                              </div>
                              <OcancerzStarszPostItems
                                postFunction={val}
                                isPreviewMode={true}
                                onEditPost={setEditingPost}
                              />
                            </div>
                          )}
                        </div>
                      ))}

                      {/* Photo Controls 2 */}
                      <div
                        style={{
                          display: "flex",
                          gap: "10px",
                          justifyContent: "space-between",
                          marginTop: "10px",
                        }}
                      >
                        <button
                          type="button"
                          onClick={() => fileInputRef2.current?.click()}
                          className="ocancerz-control-btn"
                        >
                          🖼️ Photos
                        </button>
                        <button
                          type="button"
                          onClick={() => openCamera("constellation")}
                          className="ocancerz-control-btn"
                        >
                          📸 Camera
                        </button>
                        <input
                          ref={fileInputRef2}
                          type="file"
                          accept="image/*"
                          multiple
                          onChange={handleFileChange2}
                          style={{ display: "none" }}
                        />
                      </div>

                      {/* Photo Previews 2 */}
                      {selectedPhotos2.length > 0 && (
                        <div
                          style={{
                            display: "flex",
                            gap: "10px",
                            overflowX: "auto",
                            padding: "5px 0 20px 0",
                          }}
                        >
                          {selectedPhotos2.map((photo) => (
                            <div
                              key={photo.id}
                              style={{
                                position: "relative",
                                minWidth: "60px",
                                display: "flex",
                                flexDirection: "column",
                                alignItems: "center",
                              }}
                            >
                              <img
                                src={photo.previewUrl}
                                alt="preview"
                                style={{
                                  width: "60px",
                                  height: "60px",
                                  objectFit: "cover",
                                  borderRadius: "4px",
                                }}
                              />
                              <button
                                onClick={() => removePhoto2(photo.id)}
                                style={{
                                  position: "absolute",
                                  top: -5,
                                  right: -5,
                                  background: "red",
                                  color: "white",
                                  border: "none",
                                  borderRadius: "50%",
                                  width: "20px",
                                  height: "20px",
                                  cursor: "pointer",
                                  fontSize: "12px",
                                }}
                              >
                                ×
                              </button>
                              {photo.timestamp && (
                                <div
                                  style={{
                                    fontSize: "9px",
                                    color: "#888",
                                    marginTop: "4px",
                                    textAlign: "center",
                                    width: "80px",
                                    wordWrap: "break-word",
                                  }}
                                >
                                  {photo.timestamp.split(",")[0]}
                                </div>
                              )}
                            </div>
                          ))}
                        </div>
                      )}

                      {/* Post Button 2 */}
                      {auth.loginVar && (
                        <button
                          onClick={handleConstellationSubmit}
                          disabled={isSubmittingConstellation}
                          style={{
                            background: "#00008b",
                            color: "white",
                            border: "none",
                            padding: "10px",
                            borderRadius: "4px",
                            cursor: isSubmittingConstellation
                              ? "not-allowed"
                              : "pointer",
                            fontWeight: "bold",
                            marginTop: "15px",
                            opacity: isSubmittingConstellation ? 0.7 : 1,
                          }}
                        >
                          {isSubmittingConstellation
                            ? "Posting..."
                            : "Constellation"}
                        </button>
                      )}
                    </div>

                    {theOcancerStarForms && (
                      <OcancerzStarFormList
                        onEditPost={setEditingPost}
                        refreshFeed={refreshFeed}
                        postFunction={theOcancerStarForms}
                      />
                    )}
                  </aside>

                  <svg
                    ref={svgRef}
                    width="100%"
                    height="100%"
                    style={{
                      border: "none", // Let the SCSS handle the wrapper border
                      background: "white", // Force white background
                    }}
                    onMouseDown={handleMouseDown}
                    onTouchStart={handleTouchStart}
                  >
                    <g transform={`scale(${zoom})`}>
                      {circles.map((circle, index) => (
                        <React.Fragment key={index}>
                          <circle
                            cx={circle.x}
                            cy={circle.y}
                            r={circle.r}
                            fill={
                              circle.text === "You"
                                ? "rgba(123, 0, 255, 0.1)" // A very soft purple background for "You"
                                : "none"
                            }
                            stroke="#00008b" // Deep Blue Circles
                            strokeWidth={circle.text === "You" ? "2" : "1"}
                          />
                          <text
                            x={circle.x}
                            y={circle.y + 5}
                            textAnchor="middle"
                            fill="#7b00ff" // Purple Text
                            fontWeight={
                              circle.text === "You" ? "bold" : "normal"
                            }
                          >
                            {circle.text}
                          </text>
                        </React.Fragment>
                      ))}
                    </g>
                  </svg>
                </div>
              </div>
            )}

            {/* Camera Modal */}
            {/* Camera Modal */}
            {/* Camera Modal */}
            {/* 🌟 BUBBLES EDITOR MODAL 🌟 */}
            {editingPost && (
              <div
                style={{
                  position: "fixed",
                  top: 0,
                  left: 0,
                  right: 0,
                  bottom: 0,
                  backgroundColor: "rgba(0,0,0,0.8)",
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "center",
                  alignItems: "center",
                  zIndex: 10001, // Sits above the canvas
                  padding: "20px",
                }}
              >
                <div
                  style={{
                    background: "white",
                    padding: "15px",
                    borderRadius: "8px",
                    width: "100%",
                    maxWidth: "600px",
                    maxHeight: "90vh",
                    overflowY: "auto",
                    position: "relative",
                  }}
                >
                  <button
                    onClick={() => {
                      setEditingPost(null);
                      setRefreshFeed((prev) => prev + 1);
                    }}
                    style={{
                      position: "absolute",
                      top: "10px",
                      right: "15px",
                      background: "transparent",
                      color: "#00008b",
                      border: "none",
                      fontSize: "24px",
                      cursor: "pointer",
                      zIndex: 10,
                    }}
                  >
                    ×
                  </button>
                  <TgridEditorForm
                    editingPost={editingPost}
                    setEditingPost={setEditingPost}
                  />
                </div>
              </div>
            )}
            {showCamera && (
              <div
                style={{
                  position: "fixed",
                  top: 0,
                  left: 0,
                  right: 0,
                  bottom: 0,
                  backgroundColor: "rgba(0,0,0,0.8)",
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "center",
                  alignItems: "center",
                  zIndex: 10000,
                  padding: "20px",
                }}
              >
                <div
                  style={{
                    background: "white",
                    padding: "15px",
                    borderRadius: "8px",
                    width: "100%",
                    maxWidth: "500px",
                  }}
                >
                  {/* Modal Header with Switch Camera Button */}
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                      marginBottom: "15px",
                    }}
                  >
                    <h3 style={{ color: "#333", margin: 0 }}>Camera</h3>
                    {hasMultipleCameras && (
                      <button
                        onClick={switchCamera}
                        style={{
                          backgroundColor: "white",
                          border: "1px solid gray",
                          color: "blue",
                          padding: "5px 10px",
                          borderRadius: "4px",
                          cursor: "pointer",
                        }}
                      >
                        🔄 Switch Camera
                      </button>
                    )}
                  </div>

                  {/* Video Element (Hidden when reviewing photo) */}
                  <video
                    ref={videoRef}
                    autoPlay
                    playsInline
                    muted
                    style={{
                      width: "100%",
                      borderRadius: "8px",
                      background: "black",
                      transform:
                        currentFacingMode === "user" ? "scaleX(-1)" : "none",
                      display: !capturedPhoto ? "block" : "none",
                    }}
                  />

                  {/* Captured Photo Preview */}
                  {capturedPhoto && (
                    <img
                      src={capturedPhoto}
                      alt="captured"
                      style={{
                        width: "100%",
                        borderRadius: "8px",
                        display: "block",
                      }}
                    />
                  )}

                  {/* Controls Container */}
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                      marginTop: "15px",
                    }}
                  >
                    {/* Checkbox */}

                    {/* Action Buttons */}
                    <div
                      style={{
                        display: "flex",
                        gap: "10px",
                        flexWrap: "wrap",
                      }}
                    >
                      {!capturedPhoto ? (
                        <>
                          <button
                            onClick={closeCamera}
                            style={{
                              padding: "8px 15px",
                              borderRadius: "4px",
                              border: "1px solid gray",
                              background: "white",
                              color: "blue",
                              cursor: "pointer",
                              fontWeight: "bold",
                            }}
                          >
                            Cancel
                          </button>
                          <button
                            onClick={capturePhoto}
                            style={{
                              padding: "8px 15px",
                              borderRadius: "4px",
                              background: "#7b00ff",
                              color: "white",
                              border: "none",
                              cursor: "pointer",
                              fontWeight: "bold",
                            }}
                          >
                            📸 TAKE PHOTO
                          </button>
                        </>
                      ) : (
                        <>
                          <button
                            onClick={handleRetake}
                            style={{
                              padding: "8px 15px",
                              borderRadius: "4px",
                              border: "1px solid gray",
                              background: "white",
                              color: "blue",
                              cursor: "pointer",
                              fontWeight: "bold",
                            }}
                          >
                            Retake
                          </button>
                          <button
                            onClick={closeCamera}
                            style={{
                              padding: "8px 15px",
                              borderRadius: "4px",
                              border: "1px solid gray",
                              background: "white",
                              color: "blue",
                              cursor: "pointer",
                              fontWeight: "bold",
                            }}
                          >
                            ✅ Use Photo
                          </button>
                        </>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            )}

            {/* 5. View Mode: Grid */}
            {viewMode === "grid" && (
              <div
                style={{
                  marginTop: "20px",
                  fontStyle: "italic",
                  color: "#ccc",
                  fontSize: "1.2rem",
                  letterSpacing: "2px",
                }}
              >
                notifications ...
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default OcancerzWorldStartingConsole;
